module.exports = __webpack_public_path__ + "static/media/week-2a.385f66cd.gif";